import { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import FormFieldsTab from "./components/FormFields";
import CustomPageButtonsTab from "./components/CustomPageButtons";
import { useAppServices } from "../../../../hook/services";
import Others from "./components/Others";
import GetStarted from "./components/GetStarted";

const AppDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const AppService = useAppServices();

  const [app, setApp] = useState(null);

  // Get tab from URL query param
  const searchParams = new URLSearchParams(location.search);
  const tabFromUrl = searchParams.get("tab") || "form_fields";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const fetchApp = async () => {
    const { response } = await AppService.apps.filter({
      query: `_id=${id}`,
    });
    if (response) setApp(response.data);
  };

  useEffect(() => {
    fetchApp();
  }, []);

  // Update URL when tab changes
  const handleTabChange = (key) => {
    setActiveTab(key);
    navigate(`?tab=${key}`, { replace: true });
  };

  const tabs = [
    {
      key: "form_fields",
      label: "Form Fields",
      component: <FormFieldsTab app={app} handleRefresh={fetchApp} />,
    },
    {
      key: "custom_page_buttons",
      label: "Custom Page Buttons",
      component: <CustomPageButtonsTab app={app} handleRefresh={fetchApp} />,
    },
    {
      key: "get_started",
      label: "Get Started",
      component: <GetStarted app={app} handleRefresh={fetchApp} />,
    },
    {
      key: "others",
      label: "Others",
      component: <Others app={app} handleRefresh={fetchApp} />,
    },
  ];

  if (!app) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      {/* Header with Go Back */}
      <div className="d-flex align-items-center mb-5">
        <button
          className="btn btn-outline-primary d-flex align-items-center me-3"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left me-2"></i> Go Back
        </button>
        <h4 className="fw-bold text-dark mb-0">{app.appName} Details</h4>
      </div>

      <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
        <Nav
          variant="pills"
          className="mb-4 shadow-sm p-2 rounded bg-white py-3"
        >
          {tabs.map((tab) => (
            <Nav.Item key={tab.key}>
              <Nav.Link
                eventKey={tab.key}
                className="fw-semibold px-3 py-2"
                style={{ borderRadius: "8px" }}
              >
                {tab.label}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Tab.Content>
          {tabs.map((tab) => (
            <Tab.Pane key={tab.key} eventKey={tab.key}>
              {tab.component}
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default AppDetailPage;
